import React from 'react';
import './index.less';

import { formatMoney } from '../../../../../../../shared/format';
import { getCurrencyIcon } from '../../../../../../../../../../shared/js/get-currency-icon';

function PayoutAmount({ amount, currency, keepDecimals }) {
	return (
		<span className='payout-table--body--amount'>
			{formatMoney(amount, keepDecimals)} {getCurrencyIcon(currency)}
		</span>
	);
}

export default PayoutAmount;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-amount/index.js